export default __webpack_public_path__ + "alberta-close-button.b3164ec7559e23b620de.svg";